import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const testimonialData = [
    {
        image: 'ziedkh',
        name: 'Zied Khechin',
        designation: 'Chairman',
        location: 'Tunisia, Kairouan', 
        description: '“Joining our family is your first step to success„',
       
    },
    {
        image: 'faresbr',
        name: 'Fares Ben Romdhan',
        designation: '2020-2021 Student Branch Chair',
        location: 'Tunisia, Monastir, Ksibet el madiouni', 
        description: '“Together we RISE„',
      
    },
    {
        image: 'ikramtr',
        name: 'Ikram Touir',
        designation: 'SB CO-Founder',
        location: 'Tunisia, Madanin, Ben-Gardán', 
        description: '“Come as Student, Leave as Leader„',
    },
]


const LeadersWordTestamonial = ({column , teamStyle}) => {
    return (
        <div className="row row--15">
            {testimonialData.map((data, index) => (
                <div className={`${column}`} key={index}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`rn-box-card ${teamStyle}`}>
                            <div className="inner">
                                <figure className="thumbnail">
                                    <img src={`./images/testimonial/${data.image}.jpg`} alt="Corporate React Template" />
                                </figure>
                                <figcaption className="content">
                                    <p className="description">{data.description}</p>
                                    <h2 className="title">{data.name}</h2>
                                    <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                </figcaption>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}

export default LeadersWordTestamonial;
